import React, { useState, useEffect, useRef } from 'react';
import { Routes, Route, Outlet, Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuthStore } from './hooks/useAuthStore';
import Navigation from './components/Navigation';
import HomePage from './components/HomePage';
import SearchBar from './components/SearchBar';
import LabelPreview from './components/LabelPreview';
import PrintView from './components/PrintView';
import OperationsLanding from './components/operations/OperationsLanding';
import ItemAdmin from './components/operations/ItemAdmin';
import InventoryView from './components/operations/InventoryView';
import BinTransfer from './components/operations/BinTransfer';
import Putaway from './components/operations/Putaway';
import CaseConversion from './components/operations/CaseConversion';
import SinglesConverter from './components/operations/SinglesConverter';
import WarehouseSale from './components/operations/WarehouseSale';
import GoodsReceipt from './components/operations/GoodsReceipt';
import MaterialLabelPrinter from './components/operations/MaterialLabelPrinter';
import CartingScreen from './components/operations/CartingScreen';
import WickingScreen from './components/operations/WickingScreen';
import PouringScreen from './components/operations/PouringScreen';
import PackagingScreen from './components/operations/PackagingScreen';
import PackOutScreen from './components/operations/PackOutScreen';
import ProductionDashboard from './components/operations/ProductionDashboard';
import OperatorBadges from './components/operations/OperatorBadges';
import CartingPerformance from './components/operations/CartingPerformance';
import TankDashboard from './components/operations/TankDashboard';
import OperatorDashboard from './components/operations/OperatorDashboard';
import InProductionList from './components/operations/InProductionList';
import StationDashboard from './components/operations/StationDashboard';
import StationActivityDashboard from './components/operations/StationActivityDashboard';
import FulfillmentScanner from './components/fulfillment/FulfillmentScanner';
import PendingFulfillmentList from './components/fulfillment/PendingFulfillmentList';
import PendingFulfillmentVertical from './components/fulfillment/PendingFulfillmentVertical';
import QuickShipmentPage from './components/fulfillment/QuickShipmentPage';
import MarketShipmentsPage from './components/fulfillment/MarketShipmentsPage';
import StoreBoxPage from './components/fulfillment/StoreBoxPage';
import FulfillmentList from './components/fulfillment/FulfillmentList';
import WorkOrderList from './components/workorders/WorkOrderList';
import WorkOrderDetail from './components/workorders/WorkOrderDetail';
import LowStockDashboard from './components/operations/LowStockDashboard';
import SlowMoverDashboard from './components/operations/SlowMoverDashboard';
import StockByLocationDashboard from './components/operations/StockByLocationDashboard';
import OutOfStockRiskDashboard from './components/operations/OutOfStockRiskDashboard';
import ReorderSuggestionsDashboard from './components/operations/ReorderSuggestionsDashboard';
import OrderingDashboard from './components/operations/OrderingDashboard';
import NationalAccountsDashboard from './components/operations/NationalAccountsDashboard';
import NativeItemsPage from './components/nativeitems/NativeItemsPage';
import NativeItemDetail from './components/nativeitems/NativeItemDetail';
import NativeBinLookup from './components/nativeitems/NativeBinLookup';
import MaterialPlanningLanding from './components/materialplanning/MaterialPlanningLanding';
import VesselDetailView from './components/materialplanning/VesselDetailView';
import ShopifyOrderList from './components/shopify/ShopifyOrderList';
import ShopifyOrderDetail from './components/shopify/ShopifyOrderDetail';
import MarketResearchDashboard from './components/marketresearch/MarketResearchDashboard';
import PickingStation from './components/picking/PickingStation';
import PickTicketScreen from './components/picking/PickTicketScreen';
import PackStation from './components/packing/PackStation';
import BinLabelPrinter from './components/warehouse/BinLabelPrinter';
import PriceStickerPrinter from './components/warehouse/PriceStickerPrinter';
import KeyAccountPO from './components/keyaccounts/KeyAccountPO';
import BnShippingLabels from './components/keyaccounts/BnShippingLabels';
import KeyAccountCheckStation from './components/keyaccounts/KeyAccountCheckStation';
import WickTesting from './components/production/WickTesting';
import WickTestLab from './components/production/WickTestLab';
import WickTestLabels from './components/production/WickTestLabels';
import WickTestPourSheet from './components/production/WickTestPourSheet';
import BinContentsPage from './components/warehouse/BinContentsPage';
import AmazonDashboard from './components/amazon/AmazonDashboard';
import FaireReconciliation from './components/faire/FaireReconciliation';
import FoxtrotOrders from './components/foxtrot/FoxtrotOrders';
import NativeOrderNew from './components/nativeorders/NativeOrderNew';
import NativePurchaseOrderNew from './components/nativepurchasing/NativePurchaseOrderNew';
import NativeWorkOrderNew from './components/nativeproduction/NativeWorkOrderNew';
import NativeInventoryAdjustmentNew from './components/nativeinventory/NativeInventoryAdjustmentNew';
import NativeAssemblyBuildNew from './components/nativeinventory/NativeAssemblyBuildNew';
import NativeWoSuggestions from './components/nativeproduction/NativeWoSuggestions';
import NativeDocsList from './components/nativeinventory/NativeDocsList';
import NativeItemNew from './components/nativeitems/NativeItemNew';
import NativeEntityNew from './components/nativerecords/NativeEntityNew';
import NativeTransferNew from './components/nativeinventory/NativeTransferNew';
import NativeFulfillmentNew from './components/nativeinventory/NativeFulfillmentNew';
import NativeReceiptNew from './components/nativeinventory/NativeReceiptNew';
import NativePaymentNew from './components/nativerecords/NativePaymentNew';
import NativeInvoiceNew from './components/nativerecords/NativeInvoiceNew';
import NativeEstimateNew from './components/nativerecords/NativeEstimateNew';
import GlobalSearchResults from './components/GlobalSearchResults';
import RecordsHome from './components/nativerecords/RecordsHome';
import SalesOrderRecord from './components/nativerecords/SalesOrderRecord';
import PurchaseOrderRecord from './components/nativerecords/PurchaseOrderRecord';
import WorkOrderRecord from './components/nativerecords/WorkOrderRecord';
import CustomerRecord from './components/nativerecords/CustomerRecord';
import VendorRecord from './components/nativerecords/VendorRecord';
import DocumentOutbox from './components/nativerecords/DocumentOutbox';
import WorkshopDashboard from './components/workshops/WorkshopDashboard';
import WorkshopCalendar from './components/workshops/WorkshopCalendar';
import WorkshopSessionList from './components/workshops/WorkshopSessionList';
import WorkshopSessionDetail from './components/workshops/WorkshopSessionDetail';
import WorkshopBookingList from './components/workshops/WorkshopBookingList';
import WorkshopLocationManager from './components/workshops/WorkshopLocationManager';
import WorkshopTypeManager from './components/workshops/WorkshopTypeManager';
import WorkshopRecurringRules from './components/workshops/WorkshopRecurringRules';
import WorkshopReports from './components/workshops/WorkshopReports';
import WorkshopMigrationStatus from './components/workshops/WorkshopMigrationStatus';
import ExperimentDashboard from './components/experiments/ExperimentDashboard';
import ExperimentCreator from './components/experiments/ExperimentCreator';
import ExperimentDetail from './components/experiments/ExperimentDetail';
import ExperimentResults from './components/experiments/ExperimentResults';
import FeatureFlagList from './components/experiments/FeatureFlagList';
import Settings from './components/Settings';
import PublishedToolPage from './components/tools/PublishedToolPage';
import DeliveryDispatch from './components/delivery/DeliveryDispatch';
import DriverApp from './components/delivery/DriverApp';
import DeliveryTracking from './components/delivery/DeliveryTracking';
import { supabase } from './lib/supabase';
import NsModeBar, { nsModeActive } from './components/nsmode/NsModeBar';
import './App.css';

// Add auth token to all API requests
axios.interceptors.request.use(async (config) => {
  if (config.url?.startsWith('/api/') && supabase) {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.access_token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${session.access_token}`;
      }
    } catch (e) {
      // Silently continue — server will reject if auth is truly needed
    }
  }
  return config;
});

function LabelPrinter() {
  const [selectedItem, setSelectedItem] = useState(null);
  const [quantity, setQuantity] = useState(10);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const printRef = useRef();

  useEffect(() => {
    fetchStatus();
  }, []);

  const fetchStatus = async () => {
    try {
      const response = await axios.get('/api/status');
      setStatus(response.data);
    } catch (error) {
      console.error('Failed to fetch status:', error);
    }
  };

  const handleItemSelect = (item) => {
    setSelectedItem(item);
  };

  const handleQuantityChange = (e) => {
    const value = parseInt(e.target.value);
    if (value > 0 && value <= 100) {
      setQuantity(value);
    }
  };

  const handleSync = async () => {
    setLoading(true);
    try {
      const response = await axios.post('/api/sync');
      alert(`Sync complete: ${response.data.count} items updated`);
      fetchStatus();
    } catch (error) {
      alert('Sync failed. Please try again.');
    }
    setLoading(false);
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="app">
      <header className="header">
        <h1>Carton Label System</h1>
        <div className="header-actions">
          {status && (
            <span className="status">
              {status.itemCount} items | Last sync: {new Date(status.lastSync).toLocaleDateString()}
            </span>
          )}
          <button onClick={handleSync} disabled={loading} className="sync-btn">
            {loading ? 'Syncing...' : 'Sync NetSuite'}
          </button>
        </div>
      </header>

      <main className="main-content">
        <div className="control-panel">
          <SearchBar onItemSelect={handleItemSelect} />

          {selectedItem && (
            <div className="selected-item">
              <h3>Selected Item</h3>
              <div className="item-details">
                <p><strong>SKU:</strong> {selectedItem.sku}</p>
                <p><strong>Description:</strong> {selectedItem.description}</p>
                <p><strong>Brand:</strong> {selectedItem.brand}</p>
                <p><strong>Case Qty:</strong> {selectedItem.case_qty}</p>
                <p><strong>UPC:</strong> {selectedItem.upc}</p>
              </div>

              <div className="quantity-control">
                <label htmlFor="quantity">Labels to Print:</label>
                <input
                  type="number"
                  id="quantity"
                  value={quantity}
                  onChange={handleQuantityChange}
                  min="1"
                  max="100"
                />
              </div>

              <button onClick={handlePrint} className="print-btn">
                Print Labels
              </button>
            </div>
          )}
        </div>

        <div className="preview-panel">
          {selectedItem && (
            <>
              <h3>Label Preview</h3>
              <LabelPreview item={selectedItem} />
            </>
          )}
        </div>
      </main>

      <div className="print-only">
        <PrintView item={selectedItem} quantity={quantity} ref={printRef} />
      </div>
    </div>
  );
}

const HUB_URL = process.env.NODE_ENV === 'production'
  ? 'https://daydreamerconcepts.com'
  : 'http://localhost:3010';

function AuthRequired() {
  const { user, loading } = useAuthStore();
  if (loading) return null;
  if (!user) {
    // The full URL, so a scanned link (e.g. a bag slip QR code) lands back on
    // its page after signing in, not the home screen.
    const redirect = encodeURIComponent(window.location.href);
    window.location.href = `${HUB_URL}?redirect=${redirect}`;
    return null;
  }
  return <Outlet />;
}

const STATION_ROUTES = ['/production/', '/picking-station', '/pick-tickets', '/pack-station', '/pending-fulfillment/vertical', '/ops/', '/delivery/driver', '/track/'];

function isStationRoute(pathname) {
  if (pathname === '/ops') return false;
  return STATION_ROUTES.some((r) => pathname.startsWith(r));
}

function App() {
  const { initialize } = useAuthStore();
  const location = useLocation();
  const stationMode = isStationRoute(location.pathname);
  // NS mode: arriving from ns.daydreamerconcepts.com with ?ns=1 keeps the
  // NetSuite menu bar up across Run so cross-app record/create flows don't
  // lose the chrome. nsModeActive() also persists/clears the flag.
  const nsMode = nsModeActive();

  useEffect(() => {
    initialize();
  }, [initialize]);

  return (
    <div className="app-layout">
      {nsMode && <NsModeBar />}
      <Navigation />
      <div className={`app-main ${stationMode ? 'station-mode' : ''}`}>
      <Routes>
        {/* Auth-protected routes (require Hub login) */}
        <Route element={<AuthRequired />}>
          <Route path="/" element={<Navigate to="/ops" replace />} />
          <Route path="/labels" element={<LabelPrinter />} />
          <Route path="/ops" element={<OperationsLanding />} />
          <Route path="/goods-receipt" element={<GoodsReceipt />} />
          <Route path="/material-labels" element={<MaterialLabelPrinter />} />
          <Route path="/fulfillment" element={<FulfillmentScanner />} />
          <Route path="/pending-fulfillment" element={<PendingFulfillmentList />} />

          <Route path="/fulfillment/quick-shipment" element={<QuickShipmentPage />} />
          <Route path="/fulfillment/market-shipments" element={<MarketShipmentsPage />} />
          <Route path="/fulfillment/store-box" element={<StoreBoxPage />} />
          <Route path="/workorders" element={<WorkOrderList />} />
          <Route path="/workorders/:workOrderNumber" element={<WorkOrderDetail />} />
          {/* /ops/:sku routes moved to public section — ItemAdmin handles its own PIN auth */}
          <Route path="/low-stock" element={<LowStockDashboard />} />
          <Route path="/slow-movers" element={<SlowMoverDashboard />} />
          <Route path="/stock-by-location" element={<StockByLocationDashboard />} />
          <Route path="/oos-risk" element={<OutOfStockRiskDashboard />} />
          <Route path="/reorder-suggestions" element={<ReorderSuggestionsDashboard />} />
          <Route path="/ordering" element={<OrderingDashboard />} />
          <Route path="/national-accounts" element={<NationalAccountsDashboard />} />
          {/* Muscle-memory redirects: the two old purchasing dashboards are now tabs. */}
          <Route path="/oil-ordering" element={<Navigate to="/ordering?tab=oils" replace />} />
          <Route path="/materials-ordering" element={<Navigate to="/ordering?tab=vessels" replace />} />
          <Route path="/native-items" element={<NativeItemsPage />} />
          <Route path="/native-items/new" element={<NativeItemNew />} />
          <Route path="/native-items/bin" element={<NativeBinLookup />} />
          <Route path="/native-items/bin/:binCode" element={<NativeBinLookup />} />
          <Route path="/native-items/:idOrSku" element={<NativeItemDetail />} />
          <Route path="/material-planning" element={<MaterialPlanningLanding />} />
          <Route path="/material-planning/:vesselSku" element={<VesselDetailView />} />
          <Route path="/shopify/:store/orders" element={<ShopifyOrderList />} />
          <Route path="/marketplace/:store/orders" element={<ShopifyOrderList />} />
          <Route path="/shopify/:store/order/:id" element={<ShopifyOrderDetail />} />
          <Route path="/market-research" element={<MarketResearchDashboard />} />
          <Route path="/bin-labels" element={<BinLabelPrinter />} />
          <Route path="/price-stickers" element={<PriceStickerPrinter />} />
          <Route path="/key-account-po" element={<KeyAccountPO />} />
          <Route path="/bn-shipping-labels" element={<BnShippingLabels />} />
          <Route path="/station/key-account-check" element={<KeyAccountCheckStation />} />
          <Route path="/wick-testing" element={<WickTesting />} />
          <Route path="/bin/:binCode" element={<BinContentsPage />} />
          <Route path="/amazon" element={<AmazonDashboard />} />
          <Route path="/faire" element={<FaireReconciliation />} />
          <Route path="/foxtrot" element={<FoxtrotOrders />} />
          <Route path="/native-orders/new" element={<NativeOrderNew />} />
          <Route path="/native-purchase-orders/new" element={<NativePurchaseOrderNew />} />
          <Route path="/native-work-orders/new" element={<NativeWorkOrderNew />} />
          {/* Edit in place — the same forms in edit mode (PATCH, not POST).
              These four documents post nothing, so amending them is a data
              change; the server decides what may change per document. */}
          <Route path="/native-orders/:id/edit" element={<NativeOrderNew />} />
          <Route path="/native-purchase-orders/:id/edit" element={<NativePurchaseOrderNew />} />
          <Route path="/native-work-orders/:id/edit" element={<NativeWorkOrderNew />} />
          <Route path="/native-inventory-adjustments/new" element={<NativeInventoryAdjustmentNew />} />
          <Route path="/native-assembly-builds/new" element={<NativeAssemblyBuildNew />} />
          <Route path="/native-work-orders/suggestions" element={<NativeWoSuggestions />} />
          <Route path="/native-inventory-adjustments" element={<NativeDocsList kind="adjustments" />} />
          <Route path="/native-assembly-builds" element={<NativeDocsList kind="builds" />} />
          <Route path="/native-transfers/new" element={<NativeTransferNew />} />
          <Route path="/native-receipts/new" element={<NativeReceiptNew />} />
          <Route path="/native-receipts" element={<NativeDocsList kind="receipts" />} />
          <Route path="/native-fulfillments" element={<NativeDocsList kind="fulfillments" />} />
          <Route path="/native-transfers" element={<NativeDocsList kind="transfers" />} />
          <Route path="/native-payments" element={<NativeDocsList kind="payments" />} />
          <Route path="/native-invoices" element={<NativeDocsList kind="invoices" />} />
          <Route path="/native-credit-memos" element={<NativeDocsList kind="creditMemos" />} />
          <Route path="/records/estimates" element={<NativeDocsList kind="estimates" />} />
          <Route path="/records/return-authorizations" element={<NativeDocsList kind="rmas" />} />
          <Route path="/native-fulfillments/new" element={<NativeFulfillmentNew />} />
          <Route path="/native-payments/new" element={<NativePaymentNew />} />
          <Route path="/native-invoices/new" element={<NativeInvoiceNew />} />
          <Route path="/records/estimates/new" element={<NativeEstimateNew kind="estimate" />} />
          <Route path="/records/return-authorizations/new" element={<NativeEstimateNew kind="rma" />} />
          <Route path="/records/estimates/:id/edit" element={<NativeEstimateNew kind="estimate" />} />
          <Route path="/records/return-authorizations/:id/edit" element={<NativeEstimateNew kind="rma" />} />
          {/* Native record pages (tasks #62/#60) — read-only NetSuite-record
              replacements served from the synced mirrors */}
          <Route path="/search" element={<GlobalSearchResults />} />
          <Route path="/records" element={<RecordsHome />} />
          <Route path="/records/outbox" element={<DocumentOutbox />} />
          <Route path="/records/sales-orders/:id" element={<SalesOrderRecord />} />
          <Route path="/records/purchase-orders/:id" element={<PurchaseOrderRecord />} />
          <Route path="/records/work-orders/:id" element={<WorkOrderRecord />} />
          <Route path="/records/customers/new" element={<NativeEntityNew kind="customers" />} />
          <Route path="/records/vendors/new" element={<NativeEntityNew kind="vendors" />} />
          <Route path="/records/customers/:id" element={<CustomerRecord />} />
          <Route path="/records/vendors/:id" element={<VendorRecord />} />
          <Route path="/workshops" element={<WorkshopDashboard />} />
          <Route path="/workshops/calendar" element={<WorkshopCalendar />} />
          <Route path="/workshops/sessions" element={<WorkshopSessionList />} />
          <Route path="/workshops/sessions/:id" element={<WorkshopSessionDetail />} />
          <Route path="/workshops/bookings" element={<WorkshopBookingList />} />
          <Route path="/workshops/locations" element={<WorkshopLocationManager />} />
          <Route path="/workshops/types" element={<WorkshopTypeManager />} />
          <Route path="/workshops/recurring" element={<WorkshopRecurringRules />} />
          <Route path="/workshops/reports" element={<WorkshopReports />} />
          <Route path="/workshops/migration" element={<WorkshopMigrationStatus />} />
          <Route path="/experiments" element={<ExperimentDashboard />} />
          <Route path="/experiments/new" element={<ExperimentCreator />} />
          <Route path="/experiments/flags" element={<FeatureFlagList />} />
          <Route path="/experiments/:id" element={<ExperimentDetail />} />
          <Route path="/experiments/:id/results" element={<ExperimentResults />} />
          <Route path="/experiments/:id/edit" element={<ExperimentCreator />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/tools/:toolId" element={<PublishedToolPage />} />
          <Route path="/delivery/dispatch" element={<DeliveryDispatch />} />
          <Route path="/delivery/driver" element={<DriverApp />} />
          {/* Per-person productivity and scan-integrity flags. Auth-protected on
              purpose: these are management numbers, not a floor display. The public
              /production/dashboard TV board stays throughput-only. */}
          <Route path="/production/activity" element={<StationActivityDashboard />} />
        </Route>

        {/* QR-scannable routes — PIN auth handled by ItemAdmin component */}
        <Route path="/ops/:sku" element={<ItemAdmin />} />
        <Route path="/ops/:sku/inventory" element={<InventoryView />} />
        <Route path="/ops/:sku/transfer" element={<BinTransfer />} />
        <Route path="/ops/:sku/putaway" element={<Putaway />} />
        <Route path="/ops/:sku/convert" element={<CaseConversion />} />
        <Route path="/ops/:sku/singles-convert" element={<SinglesConverter />} />
        <Route path="/ops/:sku/warehouse-sale" element={<WarehouseSale />} />

        {/* Public dashboard routes (no Hub auth -- for warehouse TVs) */}
        <Route path="/pending-fulfillment/vertical" element={<PendingFulfillmentVertical />} />
        <Route path="/production/dashboard" element={<ProductionDashboard />} />
        <Route path="/production/tanks" element={<TankDashboard />} />
        <Route path="/production/carting" element={<CartingScreen />} />
        <Route path="/production/wicking" element={<WickingScreen />} />
        <Route path="/production/pouring" element={<PouringScreen />} />
        <Route path="/production/packaging" element={<PackagingScreen />} />
        <Route path="/production/pack-out" element={<PackOutScreen />} />
        <Route path="/production/badges" element={<OperatorBadges />} />
        {/* Wick testing floor screens: the pour list, QR labels, and the lab
            burn-reading form the labels open. See WickTestLab.js. */}
        <Route path="/production/wick-pour" element={<WickTestPourSheet />} />
        <Route path="/production/wick-test-labels" element={<WickTestLabels />} />
        <Route path="/production/wick-test" element={<WickTestLab />} />
        <Route path="/production/wick-test/:code" element={<WickTestLab />} />
        <Route path="/production/carting/performance" element={<CartingPerformance />} />
        <Route path="/production/operators" element={<OperatorDashboard />} />
        <Route path="/production/in-progress" element={<InProductionList />} />
        <Route path="/production/stations" element={<StationDashboard />} />
        <Route path="/fulfillment/list" element={<FulfillmentList />} />
        <Route path="/picking-station" element={<PickingStation />} />
        <Route path="/pick-tickets" element={<PickTicketScreen />} />
        <Route path="/pack-station" element={<PackStation />} />

        {/* Public customer delivery tracking — token-gated */}
        <Route path="/track/:token" element={<DeliveryTracking />} />
      </Routes>
      </div>
    </div>
  );
}

export default App;